<template> 
    <div 
        v-show="main_text" 
        class="pop-body-present flex_layout flex_y_end">
        <div 
            :class="{paddf:sub_text}" 
            class="pop-body-present-bd flex_layout flex_flexDirection_column flex_x_spacebetween">
            <div class="line1 flex_layout flex_y_start">
                <p 
                    class="pf-regular" 
                    :class="{ellipsis:main_text_len > 10}" 
                    v-html="formatHtmlYerrowTtitle(main_text)">
                </p>
                <div 
                    class="icon" 
                    :class="{titleoverflow:main_text_len > 10}">
                    <img :src="corner_icon">
                </div>
            </div>
            <div v-show="sub_text" class="line2">
                <p 
                    class="pf-regular ellipsis" 
                    v-html="formatHtmlYerrowSubTtitle(sub_text)">
                </p>
            </div>
            <!-- 0:后台配置（礼包图样式） -->
            <div v-show="show_main_icon_type == 0" class="gift">
                <img :src="main_icon">
            </div>
            <!-- 1：作品封面（天降样式/历史记录样式） -->
            <div v-show="show_main_icon_type >= 1" class="gift">
                <img :src="giftbg_icon">
                <div class="banner" :class="{small:t_remaining > 0}"><img :src="main_icon"></div>
                <div v-show="t_remaining > 0" class="timer flex_layout flex_x_spacebetween">
                    <div class="timer-item flex_layout flex_xy_center"><span>{{timer.hh}}</span></div>
                    <div class="timer-item flex_layout flex_xy_center"><span>{{timer.mm}}</span></div>
                    <div class="timer-item flex_layout flex_xy_center"><span>{{timer.ss}}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {getTimer} from "../js/comp";
    export default {
        name: 'InfoActivity',
            data () {
            return {
                timer : {
                    dd : '00',
                    hh : '00',
                    mm : '00',
                    ss : '00',
                    ms : '00',
                },
                t_flag : '',
                t_remaining : 0,
                t_interval  : 1000,
                just_one : true,
            }
        },
        props: {
            visible:{
                type: Boolean,
                default :false,
            },
            value:{
                type: Object,
                default () {
                    return {
                        id : 0,
                        show_main_icon_type : 0, //0:后台配置（礼包图样式） 1：作品封面（天降样式）
                        words_info:{
                            main_text : '',
                            sub_text : '',
                        },
                        image_info:{
                            corner_icon : '',
                            main_icon   : '',//http://f12stag.kkmh.com/image/160429/7u76vuhf7.webp-w320.w.jpg
                        },
                        remaining_time : 0,
                    }
                }
            },
        },
        watch: {
            value:{
                handler(val, oldVal){
                    if(val.remaining_time > 0 && this.just_one) {
                        this.just_one = false;
                        clearTimeout(this.t_flag);
                        this.t_remaining = val.remaining_time;
                        this.countdown();
                    }
                },
                deep:true,
                immediate:true //true就表示会立即执行
            },
        },
        computed: {
            show_main_icon_type(){
                let {show_main_icon_type=0} = this.value;
                return (show_main_icon_type);
            },
            main_text_len() {
                let {words_info={}} = this.value;
                if (words_info.main_text) {
                    return words_info.main_text.toString().split('#').join('').length;
                } else {
                    return 0;
                }
            },
            main_text() {
                let {words_info={}} = this.value;
                return words_info.main_text;
            },
            sub_text() {
                let {words_info={}} = this.value;
                return words_info.sub_text;
            },
            corner_icon() {
                let {image_info={}} = this.value;
                return image_info.corner_icon;
            },
            main_icon() {
                let {image_info={}} = this.value;
                return image_info.main_icon;
            },
            giftbg_icon() {
                return require("../img/ico_bg_gift2.png");
            }
        },
        created() {
        },
        methods:{
            countdown(){
                this.t_flag = setTimeout(() => {
                    this.t_remaining = this.t_remaining - this.t_interval;
                    this.timer = getTimer(this.t_remaining);
                    if (this.t_remaining > 0) {
                        this.countdown();    
                    }
                },this.t_interval)
            },
            formatHtmlYerrowTtitle(word) {
                if (!word) 
                return '';

                let ary = word.toString().split('#');
                if(ary.length==3) {
                    return ary[0]+'<span class="pf-semibold">'+ary[1]+'</span>'+ary[2];
                }

                return ary.join('');
            },
            formatHtmlYerrowSubTtitle(word) {
                if (!word) 
                return '';

                let ary = word.toString().split('#');
                if(ary.length==3) {
                    return ary[0]+'<span class="pf-regular">'+ary[1]+'</span>'+ary[2];
                }

                return ary.join('');
            },
        },
    }
</script>
<style lang="scss">
.pop-body-present{
    .pop-body-present-bd{
        .line1 span,.line2 span{
            color: #FDEB3D;
        }
    }
}
</style>
<style lang="scss" scoped>
@import "../../../assets/styles/mixins.scss";
.pop-body-present{
    margin-bottom: vws(-20px);
    padding: vws(16px) vws(16px) vws(36px) vws(16px);
    height:vws(266px);
    background: url("data:image/png;base64,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") no-repeat 0 0;
    background-size: 100% 100%;
    .paddf{
        padding:vws(16px) vws(48px) vws(18px) vws(36px)!important;
    }
    .pop-body-present-bd{
        padding:vws(20px) vws(48px) vws(22px) vws(36px);
        width:100%;color: #FFF;
        position:relative;
        background-image: linear-gradient(90deg, #06001B 0%, rgba(6,0,27,0.60) 100%);
        border-radius: vws(20px);
        .ellipsis {
            overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
        }
        .titleoverflow {
            position:absolute;top:0;right:vws(-52px);
        }
        .line1{
            position:relative;font-weight:bold;font-size:vws(36px);width:vws(360px);margin-bottom:vws(-4px);
            p{
                white-space: nowrap;
            }
            .icon{
                margin-left:vws(4px);margin-top:vws(8px);height:vws(24px);
            }
            .icon img{
                vertical-align: top;width:auto;height:100%;
            }
        }
        
        .line2{
            width:vws(440px);font-size:vws(24px);transform: scale(.917);transform-origin: left bottom;
        }
        .gift{
            position:absolute;right:vws(52px);bottom:0;width:vws(200px);height:vws(200px);overflow:hidden;
            .timer{
                width:vws(116px);position:absolute;left:vws(65px);bottom:vws(6.8px);
                .timer-item{
                    background: #333;
                    width:vws(37.36px);height:vws(42.68px);border-radius: vws(6px);
                    transform:scale(.75);transform-origin: left bottom;
                    span{
                        line-height:vws(24px);
                        font-weight:bold;
                    }
                }
                .timer-dian{color:#000}
            }
            .banner{
                position:absolute;
                left: vws(24px);
                top: vws(20px);
                width: vws(152px);
                height: vws(176px);
                overflow: hidden;
                border-radius: vws(6px);
            }
            .small{
                width: vws(152px);
                height: vws(136px);
            }
        }
    }
}



</style>



// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/comp/InfoActivity.vue